var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTunefundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 348,
    viewBox: "0 0 348 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.765 348C175.071 348 184.235 270.091 184.235 174V344C184.235 346.209 186.04 348.005 188.248 347.95C277.565 345.728 348 269.494 348 174C348 78.5377 275.6 2.32191 188.245 0.0520605C186.037 -0.00532302 184.235 1.79086 184.235 4V174C184.235 77.9092 175.071 0 163.765 0C152.459 0 143.294 77.9092 143.294 174C143.294 81.4988 134.13 6.52075 122.824 6.52075C111.517 6.52075 102.353 81.4988 102.353 174C102.353 266.48 111.517 341.479 122.824 341.479C134.13 341.479 143.294 266.48 143.294 174C143.294 270.091 152.459 348 163.765 348ZM77.7892 326.25C87.9633 326.25 96.212 258.09 96.212 174C96.212 89.9099 87.9633 21.75 77.7892 21.75C67.6139 21.75 59.3652 89.9099 59.3652 174C59.3652 258.09 67.6139 326.25 77.7892 326.25ZM51.1765 176.167C51.1765 239.845 45.6777 291.437 38.8934 291.437C32.1102 291.437 26.6115 239.845 26.6115 176.167C26.6115 112.51 32.1102 60.8958 38.8934 60.8958C45.6777 60.8958 51.1765 112.51 51.1765 176.167ZM12.2819 171.812C12.2819 203.057 9.53312 228.375 6.14093 228.375C2.74999 228.375 0 203.057 0 171.812C0 140.589 2.74999 115.271 6.14093 115.271C9.53312 115.271 12.2819 140.589 12.2819 171.812Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTunefundIcon);
export default __webpack_public_path__ + "static/media/logo-tunefund-icon.7783edfbee947d9782256b4812ed92af.svg";
export { ForwardRef as ReactComponent };